export default __webpack_public_path__ + "static/media/12.2cdc60a1.png";